// Public frontend catalog. CRA embeds REACT_APP_* values at build time.
const ADDONS = [
  {
    "id": "member_app",
    "name": "Fitistic app + AI Coach",
    "monthly": 1395,
    "benefit": "Bring coaching, nutrition and measurable progress together in one member app.",
    "detail": "Shared member app with exercise library, workout and trainer plans, assignments, food library, meal plans, diet tracking, goals, body measurements and progress history. AI usage tokens remain extra.",
    "category": "Experience",
    "includes": [
      "AI Coach",
      "Workout & trainer tools",
      "Nutrition & meal plans",
      "Progress & analytics"
    ]
  },
  {
    "id": "staff",
    "name": "Staff management",
    "monthly": 199,
    "benefit": "Keep your team organised as the gym grows.",
    "detail": "Trainer and staff profiles, assignments and management tools.",
    "category": "Operations"
  },
  {
    "id": "crm",
    "name": "Lead management",
    "monthly": 199,
    "benefit": "Give every enquiry a clear next step.",
    "detail": "Lead pipeline, follow-ups and conversion tracking.",
    "category": "Growth"
  },
  {
    "id": "retention",
    "name": "Retention & challenges",
    "monthly": 398,
    "benefit": "Keep members motivated and bring them back before they drift away.",
    "detail": "At-risk member insights, renewal workflows, retention nudges, challenges, events, banners and member feedback in one feature.",
    "category": "Growth",
    "includes": [
      "Member retention & renewals",
      "Challenges & events",
      "Banners & member feedback"
    ]
  },
  {
    "id": "communications",
    "name": "Communication centre",
    "monthly": 149,
    "benefit": "Send the right message without rewriting it.",
    "detail": "Push, SMS and WhatsApp templates and campaign tools. Delivery credits extra.",
    "category": "Growth"
  },
  {
    "id": "social",
    "name": "Social & marketing tools",
    "monthly": 249,
    "benefit": "Bring enquiries and campaigns into one workspace.",
    "detail": "Social operations and marketing integrations. Advertising spend extra.",
    "category": "Growth"
  }
];
function numberFromEnv(env, key, fallback, max = 1000000) {
  const raw = env[key];
  const value = raw === undefined || raw === '' ? fallback : Number(raw);
  if (!Number.isFinite(value) || value < 0 || value > max) throw new Error(`Invalid pricing configuration: ${key}`);
  return Math.round(value * 100) / 100;
}
function getPricingCatalog(env = process.env) {
  return {
    currency: 'INR', annualDiscountPercent: numberFromEnv(env, 'REACT_APP_PRICING_ANNUAL_DISCOUNT_PERCENT', 20, 50),
    taxNote: env.REACT_APP_PRICING_TAX_NOTE || 'Prices exclude applicable taxes. Final tax is confirmed on your invoice.',
    tiers: [
      { id: 'small', name: 'Launch', range: 'Fewer than 50 members', min: 1, max: 49, monthly: numberFromEnv(env, 'REACT_APP_PRICING_CORE_UNDER_50_INR', 499), description: 'A strong foundation for your growing community.' },
      { id: 'medium', name: 'Grow', range: '50–100 members', min: 50, max: 100, monthly: numberFromEnv(env, 'REACT_APP_PRICING_CORE_50_100_INR', 799), description: 'Keep a busy gym running with less admin.' },
      { id: 'large', name: 'Scale', range: '100+ members', min: 101, max: null, monthly: numberFromEnv(env, 'REACT_APP_PRICING_CORE_OVER_100_INR', 999), description: 'For 101+ members. Built for your next chapter.' },
    ],
    coreFeatures: [
      { name: 'User management', benefit: 'Keep member profiles and memberships in one place.' },
      { name: 'Invoice management', benefit: 'Create invoices, track dues and record payments.' },
      { name: 'Attendance', benefit: 'See who is showing up and maintain check-in records.' },
      { name: 'Batch management', benefit: 'Organise members into manageable training groups.' },
      { name: 'Slot management', benefit: 'Schedule sessions and manage capacity.' },
      { name: 'Point of sale (POS)', benefit: 'Record supplement and merchandise sales alongside memberships.' },
      { name: 'Biometric integration', benefit: 'Sync supported biometric devices with attendance. Hardware and installation extra.' },
      { name: 'Yoga & wellbeing', benefit: 'Give members access to available yoga and stress-management content.' },
    ],
    addons: ADDONS.map(item => ({ ...item, monthly: numberFromEnv(env, `REACT_APP_PRICING_ADDON_${item.id.toUpperCase()}_INR`, item.monthly) })),
  };
}
module.exports = { getPricingCatalog };
